import Vue from 'vue'
import Vuex from 'vuex'
import tableViewRoutes from './tableViewRoutes';

Vue.use(Vuex)

const lcTableViewKey = 'table-view'; //Update it when update default table view

let tableView = localStorage.getItem(lcTableViewKey);
tableView = tableView ? JSON.parse(tableView) :
  tableViewRoutes.reduce((obj, routeName) => {
    obj[routeName] = true;
    return obj;
  }, {});
let darken = localStorage.getItem('darken');
  darken = darken === undefined ? true : !!Number(darken);
let sideBar = localStorage.getItem('sideBar');
  sideBar = sideBar === undefined ? true : !!Number(sideBar);

export default new Vuex.Store({
  state: {
    page: 'page',
    tableView,
    search: '',
    dark: darken,
    sideBar: sideBar,
  },
  mutations: {
    changeSideBarView(state) {
      state.sideBar = !state.sideBar;
      localStorage.setItem('sideBar', Number(state.sideBar) + '');
    },
    mobileSettings(state,routeName) {
      state.sideBar = false;
      state.tableView[routeName] = false;
    },
    changeTableView(state, routeName) {
      state.tableView[routeName] = !state.tableView[routeName];
      localStorage.setItem(lcTableViewKey, JSON.stringify(state.tableView));
    },
    searchUpdate(state, searchWord) {
      state.search = searchWord
    },
    changeDarken(state) {
      state.dark = !state.dark;
      localStorage.setItem('darken', Number(state.dark) + '');
    }
  }
})
